import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Check } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';
import Header from '../../uiParts/Header';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const AuthPasswordResetComplete: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <CustomHead title="パスワード再設定完了 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <Check sx={styles.checkIcon} />
        <Typography sx={styles.title}>パスワードを再設定しました</Typography>
        <Typography sx={styles.text}>
          新しいパスワードでログインしてください
        </Typography>
        <Button
          fullWidth
          onClick={() => navigate('/auth/login')}
          sx={[styles.primaryButtonOutlinedColor, { mt: '80px' }]}
          variant="outlined"
        >
          ログインへ
        </Button>
      </Typography>
    </>
  );
};

export default AuthPasswordResetComplete;
